(function () {
  'use strict';

  var C = window.ADVOKAT_QUIZ;
  var LEAD = window.ADVOKAT_LEAD || {};
  var root = document.getElementById('quizCard');
  if (!C || !root || !C.steps || !C.steps.length) { return; }

  var STEPS = C.steps;
  var I18N = C.i18n || {};
  var AUTO_MS = C.autoAdvanceMs || 300;

  var state = {
    phase: 'quiz',
    index: 0,
    answers: {},
    other: '',
    city: '',
    name: '',
    phone: '+380 ',
    company: '',
  };

  var autoTimer = null;
  var leadRef = 'AQ-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);

  function digits(v) { return String(v || '').replace(/\D+/g, ''); }

  function formatPhone(value) {
    var d = digits(value);
    if (d.indexOf('380') === 0) { d = d.slice(3); }
    d = d.substring(0, 9);
    var out = '+380';
    if (d.length > 0) { out += ' ' + d.substring(0, 2); }
    if (d.length >= 2) { out += ' ' + d.substring(2, 5); }
    if (d.length >= 5) { out += ' ' + d.substring(5, 7); }
    if (d.length >= 7) { out += ' ' + d.substring(7, 9); }
    return out;
  }

  function emitState() {
    document.dispatchEvent(new CustomEvent('advokat:quiz-state', {
      detail: { isFinal: state.phase === 'final', done: state.phase === 'done' },
    }));
  }

  function fmt(str) {
    var args = Array.prototype.slice.call(arguments, 1);
    var i = 0;
    return String(str || '').replace(/%\d?\$?[sd]/g, function () { return args[i++]; });
  }

  function render() {
    if (state.phase === 'quiz') { renderStep(); }
    else if (state.phase === 'final') { renderFinal(); }
    else { renderDone(); }
    emitState();
  }

  function renderStep() {
    var step = STEPS[state.index];
    var total = STEPS.length;
    var pct = Math.round(((state.index + 1) / total) * 100);
    var current = state.answers[step.key];

    var optsHtml = step.options.map(function (opt) {
      var cls = 'opt';
      if ((opt.other || opt.wide) ) { cls += ' other wide'; }
      if (current && current.code === opt.code) { cls += ' sel'; }
      return '<button type="button" class="' + cls + '" data-code="' + opt.code + '"><i aria-hidden="true"></i>' + opt.label + '</button>';
    }).join('');

    var condHtml = '';
    if (current && current.other) {
      condHtml = '<div class="other-box">' +
        '<label for="qOther">' + (I18N.otherLabel || '') + '</label>' +
        '<textarea class="fld" id="qOther" maxlength="300" placeholder="' + (I18N.otherPlaceholder || '') + '">' + escapeHtml(state.other) + '</textarea>' +
        '</div>';
    } else if (current && current.city) {
      condHtml = '<div class="cond-field">' +
        '<label for="qCity">' + (I18N.cityLabel || '') + '</label>' +
        '<input class="fld" id="qCity" list="qCityList" maxlength="80" placeholder="' + (I18N.cityPlaceholder || '') + '" value="' + escapeAttr(state.city) + '">' +
        '<datalist id="qCityList">' + (C.cities || []).map(function (c) { return '<option value="' + escapeAttr(c) + '">'; }).join('') + '</datalist>' +
        '</div>';
    }

    root.innerHTML =
      '<div class="meta"><span>' + fmt(I18N.stepLabel, state.index + 1, total) + '</span><span>' + pct + '%</span></div>' +
      '<div class="bar"><i style="width:' + pct + '%"></i></div>' +
      '<p class="q">' + step.q + '</p>' +
      '<div class="opts">' + optsHtml + '</div>' +
      condHtml +
      '<div class="foot">' +
      (state.index > 0 ? '<button type="button" class="back" id="qBack">← ' + (I18N.back || '') + '</button>' : '<span></span>') +
      '<button type="button" class="btn" id="qNext"' + (current ? '' : ' disabled') + '>' + (I18N.next || '') + '</button>' +
      '</div>' +
      '<div class="trust">' + (I18N.trust || '') + '</div>';

    var oth = document.getElementById('qOther');
    if (oth) { oth.addEventListener('input', function () { state.other = oth.value.slice(0, 300); }); }
    var city = document.getElementById('qCity');
    if (city) { city.addEventListener('input', function () { state.city = city.value.slice(0, 80); }); }

    Array.prototype.forEach.call(root.querySelectorAll('.opt'), function (btn) {
      btn.addEventListener('click', function () {
        var opt = step.options.filter(function (o) { return o.code === btn.dataset.code; })[0];
        state.answers[step.key] = opt;
        render();
        if (!opt.other && !opt.city) {
          clearTimeout(autoTimer);
          autoTimer = setTimeout(goNext, AUTO_MS);
        }
      });
    });

    var nextBtn = document.getElementById('qNext');
    if (nextBtn) { nextBtn.addEventListener('click', goNext); }
    var backBtn = document.getElementById('qBack');
    if (backBtn) { backBtn.addEventListener('click', goBack); }
  }

  function goNext() {
    clearTimeout(autoTimer);
    var step = STEPS[state.index];
    if (!state.answers[step.key]) { return; }
    if (state.index < STEPS.length - 1) {
      state.index += 1;
      render();
    } else {
      state.phase = 'final';
      render();
    }
  }

  function goBack() {
    clearTimeout(autoTimer);
    if (state.phase === 'final') {
      state.phase = 'quiz';
      render();
      return;
    }
    if (state.index > 0) {
      state.index -= 1;
      render();
    }
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function renderFinal() {
    var stage = state.answers.stage;
    var contact = state.answers.contact;
    var notes = '';

    if (stage && stage.code === 'urgent') {
      notes += '<div class="cond-note">' + (I18N.urgentNote || '') + '</div>';
    }

    var messengerNote = '';
    if (contact && contact.code !== 'call') {
      messengerNote = '<div class="cond-note">' + fmt(I18N.messengerNote, contact.label) + '</div>';
    }

    root.innerHTML =
      '<div class="meta"><span>' + (I18N.finalStepLabel || '') + '</span><span>' + (I18N.finalStepSub || '') + '</span></div>' +
      '<div class="bar"><i style="width:100%"></i></div>' +
      '<p class="q">' + (I18N.finalTitle || '') + '</p>' +
      notes +
      '<input class="fld" id="qName" aria-label="' + escapeAttr(I18N.namePlaceholder || '') + '" placeholder="' + (I18N.namePlaceholder || '') + '" value="' + escapeAttr(state.name) + '">' +
      '<div class="err" data-err="name">' + (I18N.errorName || '') + '</div>' +
      '<input class="fld" id="qPhone" inputmode="tel" aria-label="' + escapeAttr(I18N.phoneLabel || '') + '" placeholder="' + (I18N.phoneLabel || '') + '" value="' + escapeAttr(state.phone) + '">' +
      '<div class="err" data-err="phone">' + (I18N.errorPhone || '') + '</div>' +
      messengerNote +
      '<input class="hp-field" tabindex="-1" autocomplete="off" id="qCompany">' +
      '<div class="foot" style="justify-content:flex-end;gap:10px;">' +
      '<button type="button" class="back" id="qBack">← ' + (I18N.back || '') + '</button>' +
      '<button type="button" class="btn full" id="qSubmit" style="flex:1">' + (I18N.submit || '') + '</button>' +
      '</div>' +
      '<div class="err" data-err="generic">' + (I18N.errorGeneric || '') + '</div>' +
      '<div class="trust">' + (I18N.trust || '') + '</div>';

    var nameEl = document.getElementById('qName');
    var phoneEl = document.getElementById('qPhone');
    var companyEl = document.getElementById('qCompany');

    if (!phoneEl.value) { phoneEl.value = '+380 '; }

    nameEl.addEventListener('input', function () { state.name = nameEl.value; });
    phoneEl.addEventListener('input', function () {
      phoneEl.value = formatPhone(phoneEl.value);
      state.phone = phoneEl.value;
    });
    phoneEl.addEventListener('keydown', function (e) {
      var isDelete = e.key === 'Backspace' || e.key === 'Delete';
      if (!isDelete) { return; }
      if (phoneEl.selectionStart === 0 && phoneEl.selectionEnd === phoneEl.value.length) {
        e.preventDefault();
        phoneEl.value = '+380 ';
        state.phone = phoneEl.value;
        return;
      }
      if (phoneEl.selectionStart <= 5) { e.preventDefault(); return; }
      e.preventDefault();
      var raw = digits(phoneEl.value);
      var clean = raw.indexOf('380') === 0 ? raw.slice(3) : raw;
      clean = clean.slice(0, -1);
      phoneEl.value = formatPhone('380' + clean);
      state.phone = phoneEl.value;
    });
    companyEl.addEventListener('input', function () { state.company = companyEl.value; });

    document.getElementById('qBack').addEventListener('click', goBack);
    document.getElementById('qSubmit').addEventListener('click', submit);
  }

  function showError(key, show) {
    var input = key === 'name' ? document.getElementById('qName')
      : key === 'phone' ? document.getElementById('qPhone') : null;
    if (input) { input.setAttribute('aria-invalid', show ? 'true' : 'false'); }
    var err = root.querySelector('[data-err="' + key + '"]');
    if (err) { err.classList.toggle('show', show); }
  }

  function validateFinal() {
    var ok = true;
    var nameOk = state.name.trim().length >= 2;
    var phoneOk = /^380\d{9}$/.test(digits(state.phone));
    showError('name', !nameOk); if (!nameOk) { ok = false; }
    showError('phone', !phoneOk); if (!phoneOk) { ok = false; }
    return ok;
  }

  var STEP_ICONS = {
    topic: '👩\u200d⚖️',
    stage: '📌',
    format: '📄',
    budget: '💰',
    contact: '🤳'
  };

  function buildMessage() {
    return STEPS.map(function (step) {
      var ans = state.answers[step.key];
      var label = ans ? ans.label : '';
      if (step.key === 'topic' && ans && ans.code === 'other' && state.other) {
        label += ' (' + state.other + ')';
      }
      if (step.key === 'format' && ans && ans.code === 'inperson' && state.city) {
        label += ', місто: ' + state.city;
      }
      var icon = STEP_ICONS[step.key] ? STEP_ICONS[step.key] + ' ' : '';
      return icon + step.q + ': ' + label;
    }).join('\n');
  }

  function submit() {
    if (state.company) {
      state.phase = 'done';
      render();
      return;
    }
    if (!validateFinal()) { return; }

    var btn = document.getElementById('qSubmit');
    btn.disabled = true;
    btn.textContent = I18N.sending || btn.textContent;
    root.querySelector('[data-err="generic"]').classList.remove('show');

    var campaign = (typeof window.ADVOKAT_CAMPAIGN === 'function') ? window.ADVOKAT_CAMPAIGN() : {};
    var payload = Object.assign({
      name: state.name.trim(),
      phone: digits(state.phone),
      topic_code: state.answers.topic ? state.answers.topic.code : '',
      message: buildMessage(),
      company: state.company || '',
      lead_ref: leadRef,
      page_url: location.href,
    }, campaign);

    var url = LEAD.ajaxUrl + (LEAD.ajaxUrl.indexOf('?') > -1 ? '&' : '?') +
      'action=advokat_submit_lead&nonce=' + encodeURIComponent(LEAD.nonce || '');

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || !res.json || !res.json.success) {
          throw res.json && res.json.data ? res.json.data : {};
        }
        state.phase = 'done';
        render();
        var dl = window.dataLayer = window.dataLayer || [];
        dl.push({ event: 'lead_submit' });
      })
      .catch(function (data) {
        btn.disabled = false;
        btn.textContent = I18N.submit || btn.textContent;
        if (data && data.field) {
          showError(data.field, true);
        } else {
          root.querySelector('[data-err="generic"]').classList.add('show');
        }
      });
  }

  function renderDone() {
    root.innerHTML =
      '<div class="done-card">' +
      '<div class="done-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.4 4.4L19.5 6.5"/></svg></div>' +
      '<h3>' + (I18N.thanksTitle || '') + '</h3>' +
      '<p>' + (I18N.thanksText || '') + '</p>' +
      '</div>';
  }

  render();
})();